"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const de_1 = __importDefault(require("date-fns/locale/de")); //
const dateDeDE = {
    name: 'de-DE',
    locale: de_1.default
};
exports.default = dateDeDE;
